import { Check, Inbox, Loader2, Send, Award, XCircle, Receipt } from "lucide-react";

const STEPS = [
  { key: "received", label: "Received", icon: Inbox },
  { key: "in_progress", label: "In progress", icon: Loader2 },
  { key: "approved", label: "Approved · ₦10k fee", icon: Receipt },
  { key: "submitted", label: "Submitted", icon: Send },
  { key: "completed", label: "Completed", icon: Award },
];

export default function FestivalRequestTimeline({ request }) {
  const currentIdx = STEPS.findIndex((s) => s.key === request.status);
  const rejected = request.status === "rejected";

  return (
    <div className="p-5 rounded-xl bg-surface border border-white/10" data-testid={`festival-timeline-${request.id}`}>
      <div className="flex flex-wrap items-start justify-between gap-3 mb-5">
        <div className="min-w-0">
          <p className="font-display font-bold text-lg">{request.festival_name}</p>
          <p className="text-xs text-foreground/60">
            {request.film_title} · requested {new Date(request.created_at).toLocaleDateString()}
            {request.updated_at ? ` · last update ${new Date(request.updated_at).toLocaleDateString()}` : ""}
          </p>
        </div>
        {rejected ? (
          <span className="px-2.5 py-1 rounded-full text-xs bg-red-500/15 text-red-400 border border-red-500/30 capitalize flex items-center gap-1">
            <XCircle className="w-3 h-3" /> Rejected
          </span>
        ) : (
          <span className="px-2.5 py-1 rounded-full text-xs bg-terracotta/15 text-terracotta border border-terracotta/30 capitalize">
            {request.status.replace("_", " ")}
          </span>
        )}
      </div>

      {rejected ? (
        <div className="text-sm text-foreground/70">
          {request.admin_note ? (
            <p className="italic">"{request.admin_note}"</p>
          ) : (
            <p>This request was not approved. Reach out to admin for details.</p>
          )}
        </div>
      ) : (
        <div className="relative">
          <div className="flex items-center justify-between gap-2">
            {STEPS.map((step, i) => {
              const reached = i <= currentIdx;
              const active = i === currentIdx;
              const Icon = step.icon;
              return (
                <div key={step.key} className="flex-1 flex flex-col items-center text-center">
                  <div
                    className={`w-9 h-9 rounded-full flex items-center justify-center border-2 transition-all ${
                      reached
                        ? "bg-terracotta border-terracotta text-white"
                        : "bg-ink border-white/15 text-foreground/40"
                    } ${active ? "ring-4 ring-terracotta/20" : ""}`}
                  >
                    {i < currentIdx ? (
                      <Check className="w-4 h-4" />
                    ) : (
                      <Icon className={`w-4 h-4 ${active && step.key === "in_progress" ? "animate-spin" : ""}`} />
                    )}
                  </div>
                  <p className={`text-xs mt-2 ${reached ? "text-foreground" : "text-foreground/40"}`}>{step.label}</p>
                </div>
              );
            })}
          </div>
          {/* Connecting line */}
          <div className="absolute top-[18px] left-[14%] right-[14%] h-[2px] -z-0 bg-white/10">
            <div
              className="h-full bg-terracotta transition-all duration-500"
              style={{ width: `${Math.max(0, (currentIdx / (STEPS.length - 1)) * 100)}%` }}
            />
          </div>
        </div>
      )}

      {request.admin_note && !rejected && (
        <p className="text-xs text-foreground/60 italic mt-4 p-2 rounded bg-ink border border-white/5">
          Admin: "{request.admin_note}"
        </p>
      )}
    </div>
  );
}
